import { useState, useEffect } from "react";
import { Input, Table, Space, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { Link } from "react-router-dom";
import { useAuthContext } from "@/components/auth/AuthProvider";
import DepartmentTypeSelect from "@/components/common/DepartmentTypeSelect";
import DepartmentSelect from "@/components/common/DepartmentSelect";
import { message as messageService } from "@/services";
import styles from "./index.module.less";

function ReceiveMessage() {
  const [code, setCode] = useState();
  const [department, setDepartment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();

  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return messageService.listMyReceiveMessage(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          department_type: code,
          department,
          start_date: startDate,
          end_date: endDate,
          search: keyword,
          page,
          page_size: pageSize,
        },
        auth.token
      );
    }
  }, [
    run,
    keyword,
    page,
    pageSize,
    auth,
    code,
    department,
    startDate,
    endDate,
  ]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "类型",
      key: "messageType",
      width: 80,
      render: (record) => record.type.name,
    },
    {
      title: "上报单位",
      key: "department",
      width: 140,
      render: (record) => record.sender.name,
    },
    {
      title: "标题",
      dataIndex: "title",
      render: (text, record) => (
        <Link to={`/workshop/mrece/detail/${record.id}`} target="_blank">
          {text}
        </Link>
      ),
    },
    {
      title: "日期",
      width: 160,
      dataIndex: "published_at",
    },
    {
      title: "状态",
      width: 140,
      dataIndex: "status_name",
    },
  ];

  return (
    <div className={styles.receiveMessage}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              单位类型：
              <DepartmentTypeSelect value={code} onChange={setCode} />
            </div>
            <div>
              单位：
              <DepartmentSelect
                value={department}
                onChange={setDepartment}
                code={code}
              />
            </div>
            <div>
              时间范围：
              <DatePicker.RangePicker
                onChange={([start, end]) => [
                  setStartDate(start.format("YYYY-MM-DD")),
                  setEndDate(end.format("YYYY-MM-DD")),
                ]}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </Space>
        </div>
      </div>
      
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default ReceiveMessage;
